module.exports = __webpack_public_path__ + "img/second_img_moren@2x.2eab82a3.png";